<script lang="ts">
  let classname = '';
  export { classname as class };
  export let numberofPaths: number = 0;
</script>

<span class={classname}>
  {#each Array(numberofPaths) as _, i}
    <span class="path{i + 1}"></span>
  {/each}
</span>
